import axios from 'axios';
import Config from '../Helpers/Config';
import {locale} from '../locale/AppLocale';
import {requiresRelogin}  from './authActions'
import {getQuery}  from '../Helpers/Url'
import uniqueId from 'lodash/uniqueId'
import {GetEntityAttribute} from "../Helpers/Entity";


export const fetch = (categoryId) => {
    return function (dispatch, getState) {

        dispatch({
            type: 'FETCHING_PRODUCT_FORM'
        });

        let queryString = [];

        if (getQuery('bulk')) {
            queryString.push(`bulk=${getQuery('bulk')}`)
        }

        if (queryString.length) {
            queryString = '?' + queryString.join('&')
        } else {
            queryString = '';
        }

        return axios.get(Config.api(`find-category/${getState().auth.business.id}/${categoryId}${queryString}`), {
            withCredentials: Config.withCredentials()
        })
            .then((response) => {
                let variants = [];
                response.data.attributes.forEach(function (group, index) {
                    group.properties.forEach(function (item, index) {
                        if (item.is_variant === true) {
                            variants.push(item.name);
                        }

                        let groupId = item.group_id;
                        let attributeId = item.id;
                        let selectOptions = item.options.map((option) => (
                            {
                                value: option.id,
                                group_id: groupId,
                                attribute_id: attributeId,
                                label: GetEntityAttribute(option,'title'),
                                field: item.name
                            }
                            //@TODO after Ramadan ,,, this called a lot ... literally a lot
                            // console.log(item.id,this.props.field.name)
                        ));

                        if (item.is_variant === false && item.has_other === true) {
                            selectOptions.push({
                                value: -1,
                                label: locale.get('specify_your_own'),
                                field: item.name,
                                group_id: groupId,
                                attribute_id: attributeId,
                            })
                        }

                        item.selectOptions = selectOptions

                    })
                });

                if (response.data.bulk) {


                    if(response.data.bulk.images){

                        response.data.bulk.images = response.data.bulk.images.map((image, index) => {
                            return {
                                id: uniqueId(),
                                name: image,
                                path: image,
                                preview: 'https://cdn1.shooq.co.il/data/full/' + image,

                            };
                        });
                    }


                    dispatch({
                        type: 'UPDATE_PRODUCT_FROM_BULK',
                        results: response.data.bulk
                    });
                }

                dispatch({
                    type: 'FETCH_PRODUCT_FORM',
                    results: response.data
                });

                dispatch({
                    type: 'UPDATE_PRODUCT_VARIANT_INDEXES',
                    variants: variants
                });

            }).catch((error) => {
                console.log(error)
                if (error.response.status === 401) {
                    dispatch(requiresRelogin(true, true))
                } else {
                    dispatch({
                        type: 'FETCHING_PRODUCT_FORM_FAILED'
                    });
                }
            });
    };
};

export const requireVariantUpdate = (bool) => {
    return {
        type: 'PRODUCT_FORM_REQUIRE_VARIANT_UPDATE',
        status: bool
    }
};